import { useQuery } from 'react-query'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import { CACHE_KEYS } from '~/constants'

export const getListings = (params) =>
  EmpriseGroup.getListings(params).then(async (resp) => {
    const {
      pagy,
      listings,
      featured_listings,
      premium_listings,
      plus_listings,
      listings_meta
    } = resp

    const dataListings = (await Deserializer.deserialize(listings)) || []
    const featured = (await Deserializer.deserialize(featured_listings)) || []
    const premiumListings =
      (await Deserializer.deserialize(premium_listings)) || []
    const plusListing = (await Deserializer.deserialize(plus_listings)) || []

    return {
      data: [
        ...featured,
        ...premiumListings,
        ...plusListing,
        ...dataListings
      ].filter(Boolean),
      pagy,
      meta: listings_meta
    }
  })

const useListingsQuery = ({ key, ...params }: any) => {
  const useQueryKey = key ? [CACHE_KEYS.listings, key] : CACHE_KEYS.listings
  const state = useQuery(useQueryKey, () => getListings(params), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    keepPreviousData: true
  })

  return state
}

export default useListingsQuery
